/**
 * reducers/test-sessions.ts
 * desc: test sessions
 * note:
 *
 */

import type { Reducer } from '@reduxjs/toolkit';
import type { TestSessionsAction } from '../actions/test-sessions';
import type { FileInfoDto } from '../../types/api/files';

export interface TestSessionsState {
    isLoading: {
        createTestSessionFile: boolean;
        deleteTestSessionFile: boolean;
        getTestSessionFile: boolean;
        getTestSessionFiles: boolean;
    };
    list: FileInfoDto[] | undefined;
}

const INITIAL_STATE: TestSessionsState = {
    isLoading: {
        createTestSessionFile: false,
        deleteTestSessionFile: false,
        getTestSessionFile: false,
        getTestSessionFiles: false,
    },
    list: undefined
};

function testSessionsReducer(state: TestSessionsState = INITIAL_STATE, action: TestSessionsAction): TestSessionsState {
    switch (action.type) {
        // CREATE Test Session File
        case 'CREATE_TEST_SESSION_FILE_ERROR':
            return _createTestSessionFileError(state);
        case 'CREATE_TEST_SESSION_FILE_REQUEST':
            return _createTestSessionFileRequest(state);
        case 'CREATE_TEST_SESSION_FILE_SUCCESS':
            return _createTestSessionFileSuccess(state, action.payload);

        // DELETE Test Session File
        case 'DELETE_TEST_SESSION_FILE_ERROR':
            return _deleteTestSessionFileError(state);
        case 'DELETE_TEST_SESSION_FILE_REQUEST':
            return _deleteTestSessionFileRequest(state);
        case 'DELETE_TEST_SESSION_FILE_SUCCESS':
            return _deleteTestSessionFileSuccess(state, action.payload);

        // GET Test Session File
        case 'GET_TEST_SESSION_FILE_ERROR':
            return _getTestSessionFileError(state);
        case 'GET_TEST_SESSION_FILE_REQUEST':
            return _getTestSessionFileRequest(state);
        case 'GET_TEST_SESSION_FILE_SUCCESS':
            return _getTestSessionFileSuccess(state);

        // GET Test Session Files
        case 'GET_TEST_SESSION_FILES_ERROR':
            return _getTestSessionFilesError(state);
        case 'GET_TEST_SESSION_FILES_REQUEST':
            return _getTestSessionFilesRequest(state);
        case 'GET_TEST_SESSION_FILES_SUCCESS':
            return _getTestSessionFilesSuccess(state, action.payload);

        default:
            return state;
    }
}



//*************************************************
//*****   CREATE Test Session File   **************
//*************************************************
function _createTestSessionFileError(state: TestSessionsState): TestSessionsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            createTestSessionFile: false,
        },
    };
}

function _createTestSessionFileRequest(state: TestSessionsState): TestSessionsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            createTestSessionFile: true,
        },
    };
}

function _createTestSessionFileSuccess(state: TestSessionsState, payload: FileInfoDto[]): TestSessionsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            createTestSessionFile: false,
        },
        list: payload,
    };
}



//*************************************************
//*****   DELETE Test Session File   **************
//*************************************************
function _deleteTestSessionFileError(state: TestSessionsState): TestSessionsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            deleteTestSessionFile: false,
        },
    };
}

function _deleteTestSessionFileRequest(state: TestSessionsState): TestSessionsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            deleteTestSessionFile: true,
        },
    };
}

function _deleteTestSessionFileSuccess(state: TestSessionsState, payload: FileInfoDto[]): TestSessionsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            deleteTestSessionFile: false,
        },
        list: payload,
    };
}



//*************************************************
//*****   GET Test Session File   *****************
//*************************************************
function _getTestSessionFileError(state: TestSessionsState): TestSessionsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTestSessionFile: false,
        },
    };
}

function _getTestSessionFileRequest(state: TestSessionsState): TestSessionsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTestSessionFile: true,
        },
    };
}

function _getTestSessionFileSuccess(state: TestSessionsState): TestSessionsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTestSessionFile: false,
        }
    };
}



//*************************************************
//*****   GET Test Session Files   ****************
//*************************************************
function _getTestSessionFilesError(state: TestSessionsState): TestSessionsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTestSessionFiles: false,
        },
    };
}

function _getTestSessionFilesRequest(state: TestSessionsState): TestSessionsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTestSessionFiles: true,
        },
    };
}

function _getTestSessionFilesSuccess(state: TestSessionsState, payload: FileInfoDto[]): TestSessionsState {
    return {
        ...state,
        isLoading: {
            ...state.isLoading,
            getTestSessionFiles: false,
        },
        list: payload,
    };
}



export default testSessionsReducer as Reducer<TestSessionsState>;
